import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=42a93d92&scoped=true"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetail.vue?vue&type=style&index=0&id=42a93d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a93d92",
  null
  
)

export default component.exports